import { render } from "./ButtonLink.vue?vue&type=template&id=5e5a6254&scoped=true"
import script from "./ButtonLink.vue?vue&type=script&lang=js"
export * from "./ButtonLink.vue?vue&type=script&lang=js"

import "./ButtonLink.vue?vue&type=style&index=0&id=5e5a6254&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5a6254"]])

export default __exports__